import {
  EntityCollection, EntityReference, FsApiError, News, Task,
} from '@fairandsmart/types';

export interface FsOrgState {
  common: CommonState;
  task: TaskState;
  news: NewsState;
}

export enum LoadingState {
  INIT,
  LOADING,
  LOADED,
}

export interface CommonState {
  notifications: { [key: string]: string | boolean };
  notificationsState: CallState;
}

export interface NewsState {
  newsToRead: number;
  feed: News[];
  feedState: CallState;
  readNewsVisibles: boolean;
}

export enum TaskPanelTab {
  USER_TASKS = 'USER_TASKS',
  REF_TASKS = 'REF_TASKS',
}

export interface TaskState {
  panelOpened: boolean;
  panelTab: TaskPanelTab;
  userTasks: EntityCollection<Task>;
  userTasksState: CallState;
  userTodos: number;
  refTasks: EntityCollection<Task>;
  refTasksState: CallState;
  currentRef: EntityReference;
}

export type CallState = LoadingState | FsApiError;
